import * as React from 'react';
import * as Modal from 'react-modal';

import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { AsyncActionStatus, TAsyncActionStatus } from '../../../store/common';
import { RemoveModalFrame, TRemoveModalFrame } from '../../../store/popups/remove';
import { IconClose } from '../../offer_stats_popup/icons/icon_close';
import { ArchiveContainer } from './frames/archive/container';
import { InitialContainer } from './frames/initial/container';
import { RemoveContainer } from './frames/remove/container';
import { RequestReviewContainer } from './frames/request_review/container';
import * as styles from './index.css';

export interface IRemoveModalProps {
  activeFrame: TRemoveModalFrame;
  isOpen: boolean;
  offer: IOfferSchema;
  status: TAsyncActionStatus;

  close(): void;
}

export class RemoveModal extends React.PureComponent<IRemoveModalProps, {}> {
  public componentDidUpdate() {
    if (this.props.status === AsyncActionStatus.Completed) {
      window.location.reload();
    }
  }

  public render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        contentLabel="RemoveModal"
        onRequestClose={this.props.close}
        style={{
          content: {
            overflow: 'visible',
            padding: '0',
            position: 'relative',
            zIndex: 101,
          },
          overlay: {
            alignItems: 'center',
            backgroundColor: 'rgba(24, 41, 48, .8)',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
          },
        }}
      >
        <button className={styles['close']} onClick={this.props.close}>
          <IconClose />
        </button>
        {this.showActiveFrame()}
      </Modal>
    );
  }

  private showActiveFrame = () => {
    switch (this.props.activeFrame) {
      case RemoveModalFrame.Archive:
        return <ArchiveContainer />;
      case RemoveModalFrame.Remove:
        return <RemoveContainer />;
      case RemoveModalFrame.RequestReview:
        return <RequestReviewContainer />;
      default:
        return <InitialContainer />;
    }
  };
}
